export enum LenderConsentStatusAPIResponse {
  NoLender = 'noLender',
  RequiredNoAction = 'requiredNoAction',
  Requested = 'requested',
  Received = 'received',
  NotRequired = 'notRequired',
}
